/* eslint-disable no-restricted-syntax */
import {
  BASE_MENU_ITEMS_FIRST_GROUP,
  BASE_MENU_ITEMS_SECOND_GROUP,
  BASE_MENU_ITEMS_THIRD_GROUP,
  FORMAT_FILE_MENU_ITEM,
  NEWS_CATEGORY_MENU_ITEM,
  SHOW_NEWS_PANEL_MENU_ITEM,
} from './site-menu-constants';

/**
 * 第一グループのメニューを組み立てる
 * @param permissions ユーザー権限
 * @returns メニュー項目配列
 */
export function buildFirstGroupMenu(permissions: { formatDownload: boolean; practiceArea: boolean }) {
  const items = [...BASE_MENU_ITEMS_FIRST_GROUP];
  if (permissions.formatDownload) {
    items.push(FORMAT_FILE_MENU_ITEM);
  }
  if (permissions.practiceArea) {
    items.unshift(NEWS_CATEGORY_MENU_ITEM);
  }
  return items;
}

/**
 * 第二グループのメニューを組み立てる
 * @returns メニュー項目配列
 */
export function buildSecondGroupMenu() {
  return [...BASE_MENU_ITEMS_SECOND_GROUP];
}

/**
 * 第三グループのメニューを組み立てる
 * @param oid 組織ID
 * @returns メニュー項目配列
 */
export function buildThirdGroupMenu(oid: string) {
  const items = [...BASE_MENU_ITEMS_THIRD_GROUP];
  if (oid === 'legalscape' || oid === 'preview_basic' || oid === 'd1_preview') {
    items.push(SHOW_NEWS_PANEL_MENU_ITEM);
  }
  return items;
}
